export default __webpack_public_path__ + "static/media/Interactive Map.2a1f0622.svg";